<script setup>
import { computed } from 'vue'

const props = defineProps({
  value: {
    type: [String, Number],
    required: true
  },
  textSize: {
    type: Number,
    required: false,
    default: 16
  },
  height: {
    type: Number,
    default: 0
  },
  numberClass: {
    type: String,
    default: 'text-inherit'
  },
  filledStarClass: {
    type: String,
    default: ''
  }, 
  emptyStarClass: {
    type: String,
    default: 'text-[#b9b9b9]'
  }, 
})

const roundedStars = computed(() => {
  // Handle null/undefined values (no reviews yet)
  const rating = Number(props.value) || 0
  const fullStars = Math.floor(rating)
  const halfStar = (rating % 1) >= 0.1 ? 1 : 0
  return { fullStars, halfStar, emptyStars: 5 - fullStars - halfStar }
})

function getIconSize() {
  // Icon size is calculated by text size in half int precission. For example: text size 8 --> icon size 2; text size 9 --> icon size 2; text size 10 --> icon size: 2.5
  return Math.round((props.textSize / 4) * 2) / 2
}
</script>

<template>
  <div
    class="flex items-center"
    :style="{
      height: `${props.height > 0? props.height + 'px' : 'auto'}`
    }"
  >
    <iconRatingStar
      v-for="starIndex in roundedStars.fullStars"
      :key="`full-${starIndex}`"
      :class="[`size-${getIconSize()}`, props.filledStarClass]"
      class="mr-1"
    />
    <div v-if="roundedStars.halfStar" class="relative">
      <iconRatingStar   
        :class="[`size-${getIconSize()}`, props.emptyStarClass]"
        class="mr-1"
      />
      <iconRatingStarHalf
        :class="[`size-${getIconSize()}`, props.filledStarClass]"
        class="absolute top-0 left-0"
      />
    </div>
    <iconRatingStar
      v-for="starIndex in roundedStars.emptyStars"
      :key="`full-${starIndex}`"
      :class="[`size-${getIconSize()}`, props.emptyStarClass]"
      class="mr-1"
    />
    <div v-if="value !== null && value !== undefined" class="ml-1 md:ml-2 font-redhat font-medium relative top-px" :class="props.numberClass" :style="{ fontSize: props.textSize + 'px' }">
      {{ (Number(value) ?? 0).toFixed(1) }}
    </div>
  </div>
</template>